import React from "react";
import { Table } from "reactstrap";

export default function ProductSizeTable(props) {
  const { sizes, onChange } = props

  function handleTableSize(e, indexTableSize) {
    const { name, value } = e.target;

    sizes[indexTableSize][name] = value;
    onChange && onChange([...sizes]);
  }

  return (
    <Table responsive>
      <tbody>
        <tr>
          <th>Tamanho</th>
          <th>Busto</th>
          <th>Cintura</th>
          <th>Quadril</th>
          <th>Comprimento</th>
        </tr>
        {sizes.map((itemSize, index) => (
          <tr key={itemSize.size}>
            <td>{itemSize.size}</td>
            <td>
              <input
                type="number"
                value={itemSize.bust}
                name="bust"
                onChange={(e) => handleTableSize(e, index)} />
            </td>
            <td>
              <input
                type="number"
                value={itemSize.waist}
                name="waist"
                onChange={(e) => handleTableSize(e, index)} />
            </td>
            <td>
              <input
                type="number"
                value={itemSize.hip}
                name="hip"
                onChange={(e) => handleTableSize(e, index)} />
            </td>
            <td>
              <input
                type="number"
                value={itemSize.lenghtSize}
                name="lenghtSize"
                onChange={(e) => handleTableSize(e, index)} />
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
}
